import { Box, Chip } from '@mui/material';
import { useManageShipmentItemsContext } from './ManageShipmentItemsContext';

const ManageShipmentItemsFilterStatusBar = () => {
  const { filters, fulfillingPharmacies, shipment, removeFilter } = useManageShipmentItemsContext();

  const chips = [
    ...(filters.recipientName
      ? [{ key: 'recipientName', label: `Recipient: ${filters.recipientName}` }]
      : []),
    ...(filters.fulfillingAt
      ? [
          {
            key: 'fulfillingAt',
            label: `Fulfilling: ${
              fulfillingPharmacies.find((p) => p.fulfillingPharmacyId === filters.fulfillingAt)
                ?.name || filters.fulfillingAt
            }`,
          },
        ]
      : []),
    ...(filters.isManual === 'manual' ? [{ key: 'isManual', label: 'Manual only' }] : []),
    ...(filters.isManual === 'non-manual' ? [{ key: 'isManual', label: 'Non-manual only' }] : []),
    ...(filters.matchPartner
      ? [{ key: 'matchPartner', label: `Partner: ${shipment.partnerName || 'Current'}` }]
      : []),
    ...(filters.matchPractice
      ? [{ key: 'matchPractice', label: `Practice: ${shipment.practiceName || 'Current'}` }]
      : []),
    ...(filters.city ? [{ key: 'city', label: `City: ${filters.city}` }] : []),
    ...(filters.state ? [{ key: 'state', label: `State: ${filters.state}` }] : []),
    ...(filters.zip ? [{ key: 'zip', label: `ZIP: ${filters.zip}` }] : []),
  ];

  if (chips.length === 0) return null;

  return (
    <Box sx={{ mt: 0, mb: 0.75, display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {chips.map(({ key, label }) => (
        <Chip
          key={key}
          label={label}
          size='small'
          color='default'
          variant='outlined'
          onDelete={() => removeFilter(key)}
          sx={{
            height: 18,
            fontSize: 9,
            fontWeight: 500,
            '& .MuiChip-label': { fontSize: 9, px: 0.75 },
          }}
        />
      ))}
    </Box>
  );
};

export default ManageShipmentItemsFilterStatusBar;
